module.exports = __webpack_public_path__ + "img/about-3.51fd8336.png";